module.exports = __webpack_public_path__ + "img/10_73.e7aaf1b8.png";